import createReactComponent from '../createReactComponent';
var Tv = createReactComponent('Tv', [['rect', {
  x: '2',
  y: '7',
  width: '20',
  height: '15',
  rx: '2',
  ry: '2',
  key: 'f237mn'
}], ['polyline', {
  points: '17 2 12 7 7 2',
  key: '11pgbg'
}]]);
export default Tv;